import { createMachine } from "xstate";
import {
  fetchOrchestrators,
  IMultiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IContext {}

type IEvent =
  | { type: "SUBMIT" }
  | { type: "ERROR" }
  | { type: "ANOTHER_ORDER_EXISTS" }
  | { type: "SUCCESS"; orchestrator: IMultiOrderOrchestrator | undefined };

export const subscribeOfferDetailsMachine = createMachine<IContext, IEvent>(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "start",
    states: {
      start: {
        on: {
          SUBMIT: {
            target: "checkOrchestrator",
          },
        },
      },
      checkOrchestrator: {
        invoke: {
          src: "fetchOrchestrator",
        },
        on: {
          SUCCESS: {
            actions: "onSubmit",
          },
          ANOTHER_ORDER_EXISTS: {
            actions: "onErrorRedirect",
            target: "start",
          },
          ERROR: {
            target: "start",
          },
        },
      },
    },
  },
  {
    services: {
      fetchOrchestrator: () => {
        return async (callback) => {
          try {
            const orchestrators = (await fetchOrchestrators()).unwrap();

            if (
              orchestrators.ftth &&
              orchestrators.ftth.orderStatus === "Draft"
            ) {
              return callback({
                type: "ANOTHER_ORDER_EXISTS",
              });
            }

            return callback({
              type: "SUCCESS",
              orchestrator: orchestrators.multiOrder,
            });
          } catch {
            callback({ type: "ERROR" });
          }
        };
      },
    },
  },
);
